const CLAVE = 'cs-dispositivo';

/** Identificador estable del navegador (X-Device-Id): ata el "dispositivo de confianza". */
export function deviceId(): string {
  try {
    let id = localStorage.getItem(CLAVE);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(CLAVE, id);
    }
    return id;
  } catch {
    return 'sin-almacenamiento';
  }
}

const CLAVE_CONFIANZA = 'cs-confianza';

/**
 * Token del dispositivo de confianza: con él la API no vuelve a pedir el código en este
 * navegador. También viaja en cookie HttpOnly; aquí queda por si el navegador la pierde.
 */
export function tokenConfianza(): string | undefined {
  try {
    return localStorage.getItem(CLAVE_CONFIANZA) ?? undefined;
  } catch {
    return undefined;
  }
}

/** Guarda el token que devolvió la API o lo borra (`undefined`) si el alumno no confió. */
export function guardarTokenConfianza(token: string | undefined): void {
  try {
    if (token) localStorage.setItem(CLAVE_CONFIANZA, token);
    else localStorage.removeItem(CLAVE_CONFIANZA);
  } catch {
    /* sin almacenamiento: queda la cookie */
  }
}
